import React from 'react'
import { IonCard, IonCardContent } from '@ionic/react'
import { Sinal } from '../models/Sinal'

interface Props {
    sinal?: Sinal,
    item?: string,
    label?: string
    onSelect?: () => any
}

const ItemSinal: React.FC<Props> = (props: Props) => {
  const urlOfItem = `assets/imgs/${props.item}.png`

  return (
    <IonCard button={true} onClick={() => props.onSelect?.()}>
      <IonCardContent className="ion-text-center">
        <img width="150px" src={props.sinal?.url || urlOfItem} key={props.sinal?.url || urlOfItem} alt={props.label} />
        <br />
        {props.label &&
                    <span>{props.label}</span>
        }
      </IonCardContent>
    </IonCard>
  )
}

export default ItemSinal
